<template>
  <div class="user">
    <el-col style="width: 180px;margin-right: 10px;">
      <el-menu
      style="padding-top: 10px;"
        background-color="#ffffff"
        active-background-color="#B5CDFB"
        text-color="#292929"
        active-text-color="#0071FE"
        border-bottom="none"
        router
        :default-active="path"
        class="muenList"
        unique-opened
        @select="enter"
      >
        <div class="listItem" v-for="(item,index) in permission_routes" :key="index">
          <template v-if="!item.hidden">
            <el-submenu v-if="hasOneShowingChild(item.children).length>0" :index="item.path">
              <template slot="title">
                <svg-icon :icon-class="item.meta.icon"  style="margin-right: 10px;font-size:18px;"/>
                <span>{{item.meta.title}}</span>
              </template>
              <el-menu-item-group class="listItemItem">
                <template v-for="(itemList,i) in hasOneShowingChild(item.children)" >
                 <el-menu-item v-if="!itemList.hidden" :index="itemList.path" :key="i">
<!--                    <svg-icon  :icon-class="itemList.meta.icon" style="margin-right: 10px" v-if="path != itemList.path" />-->
<!--                    <svg-icon  :icon-class="itemList.meta.icon_on" style="margin-right: 10px" v-else/>-->
<!--                   <span class="svg-icon" style="width: .5em; height: 0.5em;border-radius: 50%;-->
<!--                   background: #56a1ed;display: inline-block;margin-top: 17px;margin-right: 10px; "-->
<!--                        v-if="path != itemList.path"-->
<!--                   ></span>-->
<!--                   <span class="svg-icon" style="width: .5em; height: 0.5em;border-radius: 50%;-->
<!--                   background: #f06325;display: inline-block;margin-top: 17px;margin-right: 10px;"-->
<!--                        v-else-->
<!--                   ></span>-->
                    <span style="float: left;position: absolute; top:5px">{{itemList.meta.title}}</span>
                </el-menu-item>
              </template>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item v-else :index="item.path" >
              <template slot="title">
                <svg-icon  :icon-class="item.meta.icon" style="margin-right: 10px;font-size:18px;" v-if="path != item.path" />
                <svg-icon  :icon-class="item.meta.icon_on" style="margin-right: 10px;font-size:18px;" v-else/>
                <span>{{item.meta.title}}</span>
              </template>
            </el-menu-item>
          </template>

        </div>
      </el-menu>
    </el-col>
  </div>
</template>
<script>
  import {mapGetters} from "vuex";
export default {
  props: {
    language: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo", "permission_routes"])
  },
  data() {
    return {
      path: "",
    };
  },
  watch: {
    $route: "onRouteChanged"
  },
  created() {
    this.onRouteChanged();
  },
  methods: {
    hasOneShowingChild(children = []){
      let ary = [];
      const showingChildren = children.filter(item => {
        if (!item.hidden) {
          ary.push(item);
        }
      });
      return ary;
    },
    enter(index,indexPath){
      console.log("----------enter---------",index,indexPath)
      this.$emit('resizebg')

    },
    onRouteChanged() {
      let that = this;
      that.path = that.$route.path;
    }
  },
  created() {
    // for(var index in this.permission_routes){
    //     for(var item in this.permission_routes[index]){
    //     for(var i in this.permission_routes[index][item]){
    //       for(var j in this.permission_routes[index][item][i]){
    //         console.log(i + ": " + j + "===" + this.permission_routes[index][item][i][j]);
    //       }
    //       console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$")
    //     }
    //     console.log("++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++")
    //   }
    //   console.log("????" + this.permission_routes[index].meta.title)
    // }

  }
};
</script>
<style scoped>
  .listItemItem >>> span{
    color: #333333;
    font-size: 16px;
  }

  .listItemItem .is-active{
  border-left: 2px solid #0071FE;
  background-color: #F1F8FF!important;
}
.listItemItem .is-active >>> span {
  color: #0071FE !important;
    font-size: 16px;
}
.listItemItem .is-active >>> .svg-icon{
  color:#0071FE !important;
    font-size: 16px;
}
</style>
<style>
  [class*=" el-icon-"], [class^=el-icon-] {
    line-height: 20px !important;
  }
.muenList .el-submenu__icon-arrow{
  font-size: 18px;
}

.muenList .el-menu-item,
.muenList .el-submenu__title {
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  min-width: auto;
}
.muenList .el-submenu.is-active .el-submenu__title{
      border-bottom-color:#cccccc;
}
.muenList .el-menu-item-group .el-menu-item {
  height: 40px;
  line-height: 30px;
  font-size: 14px;
  border-bottom: none;
  min-width: auto;
  padding-left: 60px !important;
  padding-right: 0px!important;
}
.muenList .el-menu-item-group__title {
  padding: 0;
}
.muenList {
  border: none;
  height: 550px;
}
.svg-icon {
  vertical-align: -3.15px !important;
}
  .el-menu-item * {
    vertical-align: 0;
  }
</style>
